import * as React from "react";
import { Skeleton, Stack } from "@mui/material";

interface LoadingSkeletonProps {
  rows?: number;
}

export function LoadingSkeleton({ rows = 3 }: LoadingSkeletonProps): React.JSX.Element {
  return (
    <Stack spacing={1} role="status" aria-label="loading">
      {Array.from({ length: rows }).map((_, index) => (
        <Skeleton key={index} variant="text" height={24} />
      ))}
    </Stack>
  );
}
